import { render, staticRenderFns } from "./PwsAutoComplete.vue?vue&type=template&id=066cc3af&"
import script from "./PwsAutoComplete.vue?vue&type=script&lang=js&"
export * from "./PwsAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports